import React from "react";
import IconTextGrid from "../elements/iconTextGrid";
import LayoutSection from "../../layouts/layoutSection";
import TitreSection from "../ui/typographic/titreSection";
import { useInView } from 'react-intersection-observer';

const Produits = ({ content, pics }) => {

	const { ref: divdRef, inView: divIsVisible } = useInView({
		threshold: .2,
		triggerOnce: true
	});

	const { ref: produitsRef, inView: produitsIsVisible } = useInView({
		threshold: .2,
		triggerOnce: true
	});

	return (

		<LayoutSection reference={divdRef}>
			<TitreSection
				content={content.titre}
				subtitle={content.soustitre}
				align='text-center'
				size={5}
				inView={divIsVisible}
				reference={divdRef}
			/>
			<div ref={produitsRef} className=" grid gap-8 grid-col-4 md:grid-cols-3 md:gap-16">
				{
					Object.values(content.produits).map((product, index) => {
						return (
							<>
								<div key={product.titre + '_' + index} className={`col-span-4 md:col-span-1  ${produitsRef ? 'appear-fromleft' : ''}`}>
									<p key={index+ '_' + index} className="font-titre text-2xl" >{product.titre}</p>
								</div>
								{
									Object.values(product.productsContent).map((solution, index2) => {
										return (
											<div className={`col-span-2 md:col-span-1 ${index2 === 2 ? 'md:col-start-2' : ''}`}>
												{
													Object.values(product.productsContent).length % 2 !== 0 && index2 === ((Object.values(product.productsContent).length) - 1)
														?
														<>
															<IconTextGrid
																key={index + index2+'-'+solution.titre}
																index={index}
																index2={index2}
																reference={produitsRef}
																isVisible={produitsIsVisible}
																color={solution.color}
																img={solution.img}
																titre={solution.titre}
																description={solution.description}
																url={solution.url}
																pics={pics}
															/>
															<div key={'div_' + index} className="col-span-2 md:col-span-1">
															</div>
														</>
														:
														<IconTextGrid
															key={index + index2+'-'+solution.titre}
															index={index}
															index2={index2}
															reference={produitsRef}
															isVisible={produitsIsVisible}
															color={solution.color}
															img={solution.img}
															titre={solution.titre}
															description={solution.description}
															url={solution.url}
															pics={pics}
														/>
												}
											</div>
										)

									})
								}
							</>
						)
					})
				}
			</div>
		</LayoutSection>
	)
}


export default Produits
